<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="searchCriteria"></ng-container>

            <tt-tabs [(ttSelectedId)]="selectedBgBatchDelControl">
                <tt-tab ttId="COLLI" ttLabel="bg_batchdelcontrol_colli"></tt-tab>
                <tt-tab ttId="SKU" ttLabel="bg_batchdelcontrol_sku"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list [hidden]="selectedBgBatchDelControl !== 'COLLI'" [ttData]="itemsListControls" [ttFilter]="setting.searchtext"></tt-list>
        <tt-list [hidden]="selectedBgBatchDelControl !== 'SKU'" [ttData]="itemsListSkus" [ttFilter]="setting.searchtext"></tt-list>

        <tt-card>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <ng-container *ngTemplateOutlet="searchCriteria"></ng-container>
        </tt-card>

        <div class="col-xs-12 sp-0">
            <div class="col-xs-12 col-md-3 p-5">
                <tt-page-heading [ttModel]="'bg_batchdelcontrol_colli'" ttTranslate></tt-page-heading>
                <tt-list [ttData]="itemsListControls" [ttFilter]="setting.searchtext"></tt-list>
            </div>

            <div class="col-xs-12 col-md-3 p-5">
                <tt-page-heading [ttModel]="'bg_batchdelcontrol_sku'" ttTranslate></tt-page-heading>
                <tt-list [ttData]="itemsListSkus" [ttFilter]="setting.searchtext"></tt-list>
            </div>
        </div>

        <tt-card class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #searchCriteria>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="batchdelivery_keyno" [ttModel]="setting.batchdelivery_keyno" ttReadonly></tt-input>
        <tt-input ttRememberId="w_batchdelcontrol.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-save ttText="batchdelcontrol_approve" (ttClick)="approveChanges()" [ttLoading]="approving"></tt-button-save>
        <tt-button-goto [ttText]="'batchdelreceivelines_deviations'" [ttGoto]="'deviations'" [ttGotoParms]="{ argtype: 'batchdelivery_keyno', argvalue: setting.batchdelivery_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>
